import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Slider from '@material-ui/core/Slider';
import VolumeUp from '@material-ui/icons/VolumeUp';
import Tooltip from '@material-ui/core/Tooltip';
import { TagEditorContext } from 'app/pages/TagEditor/TagEditor';
import { ReactComponent as InfoCircleIcon } from 'assets/images/icon/info-circle.svg';
import './VolumePropertyBox.css';

enum UIComponetKey {
    value = 'value',
}

enum PropertyKey {
    volume = 'volume',
}

const VolumnSlider = withStyles({})(Slider);

const VolumePropertyBox: React.FC = () => {
    const { t } = useTranslation();
    const { markerUpdater, currentMarker: propertyData } = useContext(TagEditorContext);

    const handleChange = (propertykey: PropertyKey, key: UIComponetKey) => {
        return function (event, newValue?) {
            markerUpdater.call({ ...propertyData, [propertykey]: newValue ?? event.target[key] });
        };
    };

    return (
        <div className="VolumePropertyBox">
            <div className="BoxTitle">
                <span>{t(`propertyText.InitialVolume`)}</span>
                <span>&nbsp;</span>
                <Tooltip title={t(`propertyText.volumeHint`)}>
                    <InfoCircleIcon />
                </Tooltip>
            </div>
            <Grid container spacing={2}>
                <Grid item>
                    <VolumeUp />
                </Grid>
                <Grid item xs>
                    <VolumnSlider
                        value={propertyData.volume}
                        onChange={handleChange(PropertyKey.volume, UIComponetKey.value)}
                        aria-labelledby="continuous-slider"
                        step={5}
                        min={0}
                        max={100}
                    />
                </Grid>
                <Grid item className="volumeValue">
                    {propertyData.volume}
                </Grid>
            </Grid>
        </div>
    );
};

export default VolumePropertyBox;
